import * as React from "react";
import { forwardRef } from "react";
const SvgArrow = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 17, height: 17, viewBox: "0 0 17 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M6.7819 11.8333L10.1152 8.49996L6.7819 5.16663", stroke: "#8F979A", strokeWidth: 1.33333, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgArrow);
export { ForwardRef as ReactComponent };
